import React from "react";

/** PM prototype ShieldCheckIcon (scene2_verify.jsx) — stroke shield + check. */
export const ShieldCheckIcon: React.FC<{
  size?: number;
  className?: string;
}> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M8 1.6 L13.6 3.6 V8 C13.6 11.2 11.2 13.7 8 14.6 C4.8 13.7 2.4 11.2 2.4 8 V3.6 Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M5.4 8.1 L7.2 9.9 L10.7 5.9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShieldCheckIcon;
